import Vue from "vue";
import Router from "vue-router";
import Login from "./components/Login.vue";
import ChangePassword from "./components/ChangePassword.vue";
import ResetPassword from "./components/ResetPassword.vue";
import w2d from "./components/w2d.vue";
import store from "./store";

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: "/login",
            name: "login",
            component: Login,
            meta: {
                guest: true
            }
        },
        {
            path: "/",
            name: "w2d",
            component: w2d,
            meta: {
                requiresAuth: true,
                msg: "Welcome to Web2Desk"
            }
        },
        {
            path: "/changePwd",
            name: "changePwd",
            component: ChangePassword,
            meta: {
                requiresAuth: true,
                requiresOnline: true
            }
        },
        {
            path: "/reset",
            name: "reset",
            component: ResetPassword,
            meta: {
                guest: true
            }
        }

        /*
        {
            path: '/register',
            name: 'register',
            component: Register,
            meta: { 
                guest: true
            }
        },
        {
            path: '/dashboard',
            name: 'userboard',
            component: UserBoard,
            meta: { 
                requiresAuth: true
            }
        },
        {
            path: '/admin',
            name: 'admin',
            component: Admin,
            meta: { 
                requiresAuth: true,
                is_admin : true
            }
        }*/
    ]
});

async function redirectIfNotAuth(to, from, next) {
    const hasToken = await store.dispatch("hasToken");
    if (!hasToken) {
        next({
            path: "/login",
            params: { nextUrl: to.fullPath }
        });
    } else {
        if (to.matched.some(record => record.meta.requiresOnline)) {
            return redirectIfNotOnline(to, from, next);
        } else {
            return next();
        }
        /*
        const isAdmin = await store.dispatch("isAdmin");
        if (to.matched.some(record => record.meta.is_admin)) {
            if (isAdmin) {
                next();
            } else {
                next();
            }
        } else {
            next();
        }
        */
    }
}

async function redirectIfNotOnline(to, from, next) {
    const isOnline = await store.dispatch("isOnline");
    if (!isOnline) {
        return next(from);
    } else {
        return next();
    }
}

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        return redirectIfNotAuth(to, from, next);
    } else {
        if (to.matched.some(record => record.meta.requiresOnline)) {
            return redirectIfNotOnline(to, from, next);
        } else {
            return next();
        }
    }
});

export default router;
